export const REQUIRED_HEADERS = ['ID', 'Tipo de Item', 'Committed Date', 'Closed Date'];

// Headers obrigatórios para bloqueios
export const REQUIRED_BLOQUEIOS_HEADERS = ['ID', 'Data de Criação', 'Data de Conclusão'];

// Status válidos para roadmaps
export const VALID_ROADMAP_STATUS = ['Planejado', 'Em Progresso', 'Concluído', 'Cancelado'];

// Níveis válidos para roadmaps
export const VALID_ROADMAP_LEVELS = ['Item', 'Subitem'];

// Cores padrão para cada status do roadmap
export const ROADMAP_STATUS_COLORS = {
  'Planejado': '#64748b',     // Cinza
  'Em Progresso': '#3b82f6', // Azul
  'Concluído': '#22c55e',    // Verde
  'Cancelado': '#ef4444'     // Vermelho
};

// Cores padrão para categorias de bloqueios
export const BLOQUEIOS_CATEGORY_COLORS = {
  'Técnico': '#ef4444',      // Vermelho
  'Processo': '#f59e0b',     // Amarelo/Laranja
  'Dependência': '#8b5cf6',  // Roxo
  'Recursos': '#06b6d4',     // Azul claro
  'Externo': '#64748b',      // Cinza
  'Outro': '#10b981'         // Verde
};

export const PERCENTILE_COLORS = { P50: '#6366f1', P85: '#f59e0b', P95: '#ef4444' };
export const METRIC_COLORS = { 
  avg: '#3b82f6', 
  p50: '#10b981', 
  p85: '#f59e0b', 
  p95: '#ef4444' 
};
export const METRIC_LABELS = {
  avg: 'Média',
  p50: 'P50', 
  p85: 'P85',
  p95: 'P95'
};
export const ITEM_TYPE_COLORS = { 'User Story': '#3b82f6', 'Bug': '#ef4444' };
export const AVAILABLE_COLORS = [
  '#10b981', '#8b5cf6', '#f59e0b', '#06b6d4', '#f97316', '#ec4899', '#84cc16', '#6366f1', '#14b8a6', '#a855f7',
];

export function getItemTypeColor(type, allTypes = []) {
  const normalizedType = type?.trim();
  if (ITEM_TYPE_COLORS[normalizedType]) return ITEM_TYPE_COLORS[normalizedType];
  const otherTypes = [...new Set(allTypes.filter(t => !ITEM_TYPE_COLORS[t?.trim()]))];
  const typeIndex = otherTypes.indexOf(normalizedType);
  if (typeIndex >= 0 && typeIndex < AVAILABLE_COLORS.length) return AVAILABLE_COLORS[typeIndex];
  let hash = 0;
  for (let i = 0; i < normalizedType.length; i++) hash = ((hash << 5) - hash) + normalizedType.charCodeAt(i);
  return AVAILABLE_COLORS[Math.abs(hash) % AVAILABLE_COLORS.length];
}

export function getBloqueiosCategoryColor(category, allCategories = []) {
  const normalizedCategory = category?.trim() || 'Outro';
  if (BLOQUEIOS_CATEGORY_COLORS[normalizedCategory]) return BLOQUEIOS_CATEGORY_COLORS[normalizedCategory];
  const otherCategories = [...new Set(allCategories.filter(c => !BLOQUEIOS_CATEGORY_COLORS[c?.trim()]))];
  const categoryIndex = otherCategories.indexOf(normalizedCategory);
  if (categoryIndex >= 0 && categoryIndex < AVAILABLE_COLORS.length) return AVAILABLE_COLORS[categoryIndex];
  let hash = 0;
  for (let i = 0; i < normalizedCategory.length; i++) hash = ((hash << 5) - hash) + normalizedCategory.charCodeAt(i);
  return AVAILABLE_COLORS[Math.abs(hash) % AVAILABLE_COLORS.length];
}

export function calculatePercentile(values, percentile) {
  if (!values.length) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  const index = Math.ceil((percentile / 100) * sorted.length) - 1;
  return sorted[index] || 0;
}
